import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { TasksService } from '../../../services/tasks/tasks.service';
import { MastersService } from '../../../services/masters/masters.service';

@Component({
  selector: 'dialog-etls',
  templateUrl: './dialog-etls.component.html',
  styleUrls: ['./dialog-etls.component.scss'],
})
export class DialogEtls implements OnInit {
  @Input() title: string;
  @Input() id: string;

  @Output() uploadFileEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseAction: EventEmitter<string> = new EventEmitter<string>();

  displayed = {};
  formErrors = {};
  year;

  reloads = {
    masterdata: false,
    'masterdata-without-transactionals': false,
    inventory: false,
    investments: false,
    forms: false,
    'investments-adjustment': false,
    cnmc: false,
    installations: false,
  };

  file: File;
  allDeselected = false;
  queryString: string;
  textEmptySearch: boolean;
  iconSearch: string;
  fileUpload: File;
  filePath: string;
  constructor(
    private tasksService: TasksService,
    private mastersService: MastersService,
  ) {
    this.iconSearch = 'search';
  }

  ngOnInit() {
    this.mastersService.getRetributiveYear().subscribe((year) => (this.year = year));
  }

  objectKeys(paramObj) {
    return Object.keys(paramObj);
  }

  fileUpdate(event) {
    this.fileUpload = event.target.files[0];
  }

  resetFileUpload(event) {
    event.preventDefault();
    this.fileUpload = null;
  }

  handleCloseDialog(): void {
    this.onCloseAction.emit(this.id);
  }

  private readonly INVENTORY_SHEETS = [
    'load-v10',
    'igea-staging',
    'components',
    'aux-components',
    'regulatory',
    'regulatory-associated-works',
    'inventory-validations',
  ];

  handleReloadSheets(): void {
    const _sheets = [];
    for (const r of Object.keys(this.reloads).filter((rKey) => this.reloads[rKey])) {
      if (r.includes('inventory')) {
        _sheets.push(...this.INVENTORY_SHEETS.map((name) => ({ name, year: this.year, extra: {} })));
      } else {
        const sheet = { name: r, year: this.year, extra: {} };
        if (r.includes('masterdata')) {
          sheet.extra['skip_transactional'] = r === 'masterdata-without-transactionals';
          sheet.name = sheet.name.replace('-without-transactionals', '');
        }
        _sheets.push(sheet);
      }
    }
    this.tasksService.sheetsReload({
      sheets: _sheets,
    });
  }
}
